export default "__VITE_ASSET__BH249AUN__"